export var headerFooterSettingsApiRelativePath = "/helpcenter/headerAndFooter";
export var createHeaderFooterSettingsApi = function (baseUrl, http) {
    var apiUrl = "" + baseUrl + headerFooterSettingsApiRelativePath;
    return {
        getHeaderFooter: function (dto) { return http.get(apiUrl + "/" + dto.locale); },
        updateHeaderFooter: function (dto) {
            return http.put(apiUrl + "/" + dto.locale, dto.data);
        },
    };
};
//# sourceMappingURL=index.js.map